<template>
  <div class="rewards" :class="cssType">
    <div class="rewards-title" :class="locale"></div>
    <!-- <div class="rewards-desc">
      {{ $t('sf.rewards.desc') }}
    </div> -->
    <!-- <div class="rewards-times">
      <div class="p" v-for="(item, index) in $t('cny.rewards.times').split('\n')" :key="index">{{ item }}</div>
    </div> -->
    <div class="rewards-btns">
      <SfButton type="blue" size="small" @click="goRecharge">{{ $t('accum.goRecharge') }}</SfButton>
      <SfButton type="yellow" size="small" @click="showRecordDialog">{{ $t('accum.record') }}</SfButton>
      <SfButton type="yellow" size="small" :disabled="store.state.cpUserInfo.token && !state.canReceiveOneKey" @click="rewardsAll">{{ $t('accum.rewardsAll') }}</SfButton>
    </div>
    <div class="rewards-box">
      <div class="diff-diamond" v-html="diffDiamond"></div>
      <div class="rewards-list">
        <div
          class="rewards-item"
          :class="{}"
          v-for="(item, index) in state.rewardList"
          :key="index"
        >
          <div class="props-img-list">
            <div class="props-img-item" :class="`props-img-item-${item.props.length}`" v-for="(prop, i) in item.props" :key="i">
              <img :src="`${PUBLIC_PATH}imgs/props/${prop.id}.png`" :alt="prop.id">
            </div>
          </div>
          <div class="props-detail-list" :class="locale">
            <div class="props-detail-item" :class="`props-detail-item-${item.props.length}`" v-for="(prop, i) in item.props" :key="i">
              <span class="name">{{ $t(`props.${prop.id}`) }}</span>
              <span class="num"> * {{ prop.count }}</span>
            </div>
          </div>
          
        </div>
      </div>
      <div class="rewards-btn-list">
        <div class="rewards-btn-item" v-for="item in state.rewardList" :key="item.id">
          <div class="receive-btn can-receive" :class="locale" @click="handleReceiveReward(item)" v-if="state.lotteryTimes >= item.lotteryTimes && !globalConfig.accumulateRewardedList.includes(item.accumulateRewardCode)">{{ $t('accum.rewards.btnCanReceive') }}</div>
          <div class="receive-btn received" :class="locale" v-else-if="state.lotteryTimes >= item.lotteryTimes && globalConfig.accumulateRewardedList.includes(item.accumulateRewardCode)">{{ $t('accum.rewards.btnReceived') }}</div>
          <div class="receive-btn not-reach" :class="locale" v-else>{{ $t('accum.rewards.btnNotReach') }}</div>
          <div class="times-num">
            {{ $t('sf.rewards.lotteryNTimes', { times: item.lotteryTimes }) }}
          </div>
        </div>
      </div>
      <ProgressBar class="progress-bar" :list="state.rewardList" :lotteryTimes="state.lotteryTimes" />
    </div>
  </div>
</template>

<script setup>
import { computed, reactive, inject } from 'vue'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
import SfButton from '../SfButton'
import ProgressBar from './components/ProgressBar'
import { useStore } from 'vuex'
import { toastService } from '@/utils/toastService'
import SfActApi from '@/config/sfActApi'
import { useLog } from '@/composables/useLog'
const log = useLog()
const PUBLIC_PATH = process.env.VUE_APP_PUBLIC_PATH
const getUserLotteryDetail = inject('getUserLotteryDetail')
const globalConfig = inject('globalConfig')
const store = useStore()
const toggleRewardDialog = inject('toggleRewardDialog')
const toggleRewardRecordDialog = inject('toggleRewardRecordDialog')
const { locale, t } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
const state = reactive({
  cpUserInfo: computed(() => store.state.cpUserInfo),
  rewardList: computed(() => globalConfig.accumulateRewardList),
  // rewardList: REWARDS_LIST,
  lotteryTimes: computed(() => globalConfig.usedLotteryCount),
  rechargeDiamond: 0,
  nextDiffDiamondNum: computed(() => {
    let res = 0;
    state.rewardList.find(item => {
      if (state.rechargeDiamond < item.needPurchaseCount) {
        res = item.needPurchaseCount - state.rechargeDiamond
        return true
      }
      return false
    })
    return res
  }),
  nextDiffLotteryTimes: computed(() => {
    let res = 0;
    state.rewardList.find(item => {
      if (state.lotteryTimes < item.lotteryTimes) {
        res = item.lotteryTimes - state.lotteryTimes
        return true
      }
      return false
    })
    return res
  }),
  canReceiveAll: computed(() => { // 是否可以一键领取
    return state.rewardList.every(item => {
      return state.rechargeDiamond >= item.needPurchaseCount
    })
  }),
  receiveRewards: {},
  rewardRecordList: [],
  canReceiveOneKey: computed(() => { // 是否可以一键领取
    return state.rewardList.some(item => {
      return state.lotteryTimes >= item.lotteryTimes && !globalConfig.accumulateRewardedList.includes(item.accumulateRewardCode)
    })
  }),
})

const diffDiamond = computed(() => {
  if (state.canReceiveAll) {
    return t('sf.rewards.canReceiveAll')
  }
  const text = t('sf.rewards.diffDiamond')
  return text.replace('[diamondNum]', `
    <span style="font-weight: bold; color: #B44002;">
      ${state.nextDiffLotteryTimes}
    </span>
  `)
})

const payUrl = computed(() => {
  return process.env.VUE_APP_HISTORY_URL + locale.value
})
const goRecharge = () => {
  window.open(payUrl.value, '_blank')
}

const getRewardRecordList = async () => {
  if (!store.state.cpUserInfo.token) {
    toastService.show(t('payment.validateUser.noUserText'))
    return
  }
  const res = await SfActApi.getAccumulateRewardRecord()
  console.log('getAccumulateRewardRecord res', res)
  const accumulateRewardRecordList = res.accumulateRewardRecordList
  const result = []
  accumulateRewardRecordList.forEach(item => {
    const displayItem = globalConfig.accumulateRewardList.find(displayItem => displayItem.accumulateRewardCode === item.accumulateRewardCode)
    result.push({
      ...displayItem,
      time: item.createTime,
    })
  })
  console.log('result', result)
  toggleRewardRecordDialog(true, { list: result }, () => {})
  
}

const showRecordDialog = async () => {
  if (!store.state.cpUserInfo.token) {
    toastService.show(t('payment.validateUser.noUserText'))
    return
  }
  getRewardRecordList()
  // state.recordDialog.visible = true
}

const rewardsAll = () => {
  if (!store.state.cpUserInfo.token) {
    toastService.show(t('payment.validateUser.noUserText'))
    return
  }
  if (!state.canReceiveOneKey) {
    return
  }
  oneKeyCollect()
}

const oneKeyCollect = async () => {
  const res = await SfActApi.receiveAccumulateRewardAll()
  try {
    log.track('act_sf_receive_reward_all', {
      v1: res.accumulateRewardCodeList.join(',')
    })
  } catch (error) {
    console.error(error)
  }
  console.log('receiveAccumulateRewardAll res', res)
  toggleRewardDialog(true, { type: 'oneKey' }, () => {})
  reset()
}

const handleReceiveReward = async (item) => {
  if (!store.state.cpUserInfo.token) {
    toastService.show(t('payment.validateUser.noUserText'))
    return
  }
  const params = {
    accumulateRewardCode: item.accumulateRewardCode,
  }
  const res = await SfActApi.receiveAccumulateReward(params)
  console.log('receiveAccumulateReward', res)
  try {
    log.track('act_sf_receive_reward', {
      v1: params.accumulateRewardCode
    })
  } catch (error) {
    console.error(error)
  }
  reset()
  toggleRewardDialog(true, { props: item.props }, () => {})
}

const reset = () => {
  getUserLotteryDetail()
}
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>